module.exports = __webpack_public_path__ + "img/Truck & Drayage_3.1ecac480.png";